 import React from 'react';
import PropTypes from 'prop-types';
import {List, ListItem} from 'material-ui/List';
import Person from 'material-ui/svg-icons/social/person'
import styles from './UserModuleBlock.css';
import {white} from 'material-ui/styles/colors';
import ModuleBlock from "../ModuleBlock";
import withTranslation from "../../../../../hoc/withTranslation";
import ModuleService from "../../../../../services/module";

class UserModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired
    };

    render() {
        let content = <List>
            <ListItem
                style={styles.list}
                disabled={true}
                primaryText={this.props.t('module.user.user_count', {count: this.props.app.user_count || 0})}
                leftIcon={<Person color={white}/>}
            />
        </List>;
        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.USER)} content={content}/>
        );
    }
}

export default withTranslation(UserModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/UserModuleBlock/UserModuleBlock.js